import { Injectable } from '@angular/core';
import { ClientBaseApiService } from 'src/app/core/api/client-base-api.service';
import { HttpRequestTypes } from 'src/app/core/models/enums/http-request-types';
import { environment } from 'src/environments/environment';
import { SprayingRequest, SprayingResponse } from '../../pesttrapp/models/spraying.response';

@Injectable({
  providedIn: 'root'
})
export class SprayingService {

  constructor(private clientService: ClientBaseApiService) { }

  saveSpraying(payload:SprayingRequest) {
    let url = environment.baseApiUrl + "v2/api/device/save/spraying";
    return this.clientService.baseApiCall<Array<boolean>>({ url: url, payload: payload, requestType: HttpRequestTypes.POST });
  }

  getSprayingList(farmId) {
    let url = environment.baseApiUrl + "v2/api/device/list/spraying/" + farmId;
    return this.clientService.baseApiCall<Array<SprayingResponse>>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  deleteSpraying(sprayingId) {
    let url = environment.baseApiUrl + "v2/api/device/delete/spraying/" + sprayingId;
    return this.clientService.baseApiCall<SprayingResponse>({ url, payload: {}, requestType: HttpRequestTypes.GET })
  }


}
